var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"popupContent"},[(_vm.detailInfo.deviceNumber)?[_c('map-dialog',{staticClass:"device-info-popup",attrs:{"disabled":true,"detailInfo":_vm.detailInfo},on:{"updateValveStatus":_vm.updateValveStatus}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }